import { Link } from "react-router-dom";
import styled from "styled-components";

import COLORS from "components/atoms/colors";
import Form from "components/templates/login/Form";

import logo from "assets/images/common/logo.svg";

// 로그인 페이지
const Login = () => {
  return (
    <div className="h-full flex items-center justify-center bg-primary-background px-5">
      <div className="relative shadow-modal bg-white w-[450px] rounded-20 px-10 py-25">
        <h1
          className="flex justify-center mb-12 cursor-pointer"
          onClick={() => window.open("https://macodi.co.kr", "_blank")}
        >
          <img src={logo} alt="macodi" width={220} />
        </h1>
        <Form />
        <LinkContainer>
          <li>
            <Link to="/findId">아이디 찾기</Link>
          </li>
          <li>
            <Link to="/findPassword">비밀번호 찾기</Link>
          </li>
          <li>
            <Link to="/signup">회원가입</Link>
          </li>
        </LinkContainer>
      </div>
    </div>
  );
};

const LinkContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  li {
    display: flex;
    align-items: center;
    color: ${COLORS.black["40%"]};
  }

  li:not(:last-child)::after {
    content: "";
    display: block;
    margin: 0 12px;
    width: 1px;
    height: 12px;
    background: ${COLORS.black["20%"]};
  }
`;

export default Login;
